export default __webpack_public_path__ + "static/media/icon-4.c3183f28.svg";